import BillInvoiceList from './BillInvoiceList';

export default BillInvoiceList;
